import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Ponad 100 klientów zamówiło już u nas bezpiecznie',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Ponad 1000 klientów zamówiło już u nas bezpiecznie',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Ponad 10 000 klientów zamówiło już u nas bezpiecznie',
  },
};
